import React, { useState } from "react";
import styles from "./CookieConsent.module.scss";
import Cookies from "js-cookie";

const DEFAULT_COUNTRY = "united arab emirates";

export default function CookieConsent({ onConsent, countries = [] }) {
  const [visible, setVisible] = useState(true);

  const handleAccept = () => {
    if (!navigator.geolocation) {
      finalizeConsent(DEFAULT_COUNTRY);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        try {
          const res = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
          );
          const data = await res.json();
          const detected = data.countryName?.toLowerCase() || DEFAULT_COUNTRY;
          const found = countries.some(
            (c) => c.countryName.toLowerCase() === detected
          );
          finalizeConsent(found ? data.countryName : DEFAULT_COUNTRY);
        } catch {
          finalizeConsent(DEFAULT_COUNTRY);
        }
      },
      () => finalizeConsent(DEFAULT_COUNTRY)
    );
  };

  const handleDecline = () => {
    // User declines location-based suggestions
    finalizeConsent(DEFAULT_COUNTRY);
  };

  const finalizeConsent = (country) => {
    Cookies.set("userCountry", country, { expires: 365 });
    if (onConsent) onConsent(country);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.cookieBanner} role="region" aria-label="Cookie consent">
      <p className={styles.message}>
        We use cookies and your location to show you relevant events. Choose "Accept" to allow location-based suggestions, or we’ll default to {DEFAULT_COUNTRY}.{" "}
        <a href="/privacy-policy" className={styles.link}>
          Learn more
        </a>
      </p>

      <div className={styles.buttons}>
        <button className={styles.declineButton} onClick={handleDecline}>
          Decline
        </button>
        <button className={styles.button} onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
}
